import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'SunrunShopProductPage',
})(({ type, spacing, brandColors }) => ({
  buyNowButton: {
    width: '100%',
  },
  checkoutSection: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: spacing(1),
  },
  checkoutButtons: {
    display: 'flex',
    width: '100%',
    gap: spacing(1),
  },
  subscriptionPurchaseError: {
    ...type['16_regular'],
    color: brandColors.errorMainDark,
    margin: 0,
  },
  optionsContainer: {
    marginTop: spacing(0),

    '& > li': { padding: `calc(${spacing(0)} / 2) 0` },
  },
  cardContent: {
    ...type['18_regular'],
  },
}));

export default useStyles;
